import React from 'react';
import {
  Button,
  ButtonSize,
  Illustration,
  IllustrationIcon,
  IllustrationMode,
  IllustrationSize,
  Typography,
  TypographyVariant,
} from '@secretescapes/falcon';
import { i18n } from '@secretescapes/i18n';
import { useTranslations } from '@utils/useTranslations';
import { Container, TextBox } from './RetryBox.styles';

interface Props {
  retryFunction: () => void;
  className?: string;
  isMobile?: boolean;
  title?: string;
  subtitle?: string;
  buttonText?: string;
}

export const RetryBox = (props: Props) => {
  const { retryFunction, className, title, subtitle, buttonText, isMobile } = props;
  const { translations } = useTranslations();

  return (
    <Container className={className}>
      <Illustration
        icon={IllustrationIcon.GoneWrong}
        size={IllustrationSize.s}
        mode={IllustrationMode.light}
      />
      <TextBox>
        <Typography variant={isMobile ? TypographyVariant.b2Bold : TypographyVariant.b1Bold}>
          {title ?? i18n('retry.something.went.wrong', [], translations)}
        </Typography>
        <Typography variant={TypographyVariant.body}>
          {subtitle ?? i18n('retry.our.teams.are.working', [], translations)}
        </Typography>
      </TextBox>
      <Button size={ButtonSize.medium} onClick={retryFunction}>
        {buttonText ?? i18n('sale.offers.loading.retry', [], translations)}
      </Button>
    </Container>
  );
};
